const SET_COUNTRIES = (state, payload) => {
  state.countries = payload;
}

export {
  SET_COUNTRIES,
}